// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__AI1MQ","selectedTag":"styles_selectedTag__J5Qsz"};